const guideList = [
  {
    type: "hero",
    content: "New here? Start with `about`, `experience`, `projects`, `case-studies`, `skills`, `now`, or `gui`.",
  },
  {
    type: "system",
    label: "Guide",
    content: "This portfolio works like a simple terminal. Type a command and press Enter.",
  },
  {
    type: "info",
    label: "Try:",
    content: "`about` to learn who I am",
  },
  {
    type: "info",
    label: "Try:",
    content: "`experience` to see my background",
  },
  {
    type: "info",
    label: "Try:",
    content: "`projects` to see the kind of work I build",
  },
  {
    type: "info",
    label: "Try:",
    content: "`case-studies` for deeper project context",
  },
  {
    type: "info",
    label: "Try:",
    content: "`skills` to see what I work with",
  },
  {
    type: "info",
    label: "Try:",
    content: "`contact` to reach me",
  },
  {
    type: "info",
    label: "Try:",
    content: "`hire` if you want to work with me",
  },
  {
    type: "info",
    label: "Try:",
    content: "`availability` to see my current status",
  },
  {
    type: "info",
    label: "Try:",
    content: "`now` for my current focus and best-fit work",
  },
  {
    type: "info",
    label: "Try:",
    content: "`gui` if you want the visual version",
  },
  {
    type: "success",
    label: "Tip",
    content: "Type `help` anytime to see the full command list.",
  },
];

const aboutList = [
  {
    type: "info",
    label: "Name:",
    content: "Dagm Ayalew",
  },
  {
    type: "info",
    label: "Role:",
    content: "Mobile App Developer",
  },
  {
    type: "info",
    label: "Location:",
    content: "Addis Ababa, Ethiopia",
  },
  {
    type: "info",
    label: "Phone:",
    content: "`+251988280976`",
  },
  {
    type: "info",
    label: "Summary:",
    content:
      "Software Engineer with 2 years of React Native experience, building production fintech and e-commerce apps serving 150+ daily users.",
  },
  {
    type: "info",
    label: "Stack:",
    content: "React Native, TypeScript, Zustand, RTK Query, Realm, REST APIs, JWT, React, Next.js",
  },
  {
    type: "info",
    label: "Focus:",
    content: "Secure authentication, API integration, performance optimization, clean architecture, and smooth mobile UX.",
  },
  {
    type: "success",
    label: "Next:",
    content: "Try `experience`, `projects`, `skills`, or `contact`.",
  },
];

const projectsList = [
  {
    type: "hero",
    content: "Featured professional projects. Type `case-studies` for a fuller walkthrough.",
  },
  {
    type: "info",
    label: "Dashen Bank:",
    content: "React Native, TypeScript, REST APIs. Implemented secure API integrations, authentication flows, reusable UI patterns, loading states, and error handling for financial transactions.",
  },
  {
    type: "info",
    label: "CBE:",
    content: "React Native, TypeScript, REST APIs. Contributed mobile banking features with standardized navigation patterns, transaction-focused API flows, and reliability improvements for critical financial operations.",
  },
  {
    type: "info",
    label: "Choice Micro Finance:",
    content: "React Native, TypeScript, REST APIs. Delivered microfinance app features with secure authentication, consistent UI components, optimized loading states, and resilient error handling.",
  },
  {
    type: "info",
    label: "Order Ethiopia:",
    content: "React Native, TypeScript, Zustand, REST APIs",
  },
  {
    type: "info",
    label: "Order Ethiopia – E-Commerce Mobile App:",
    content: "Developed core e-commerce mobile features including product cards, cart, checkout, search, profile screens, location selection, reusable UI components, and smooth refresh/header animations.",
  },
  {
    type: "info",
    label: "Worklance – Job Aggregation Platform:",
    content: "React Native, Web, Telegram Mini App, Backend",
  },
  {
    type: "info",
    label: "Worklance:",
    content: "Built a cross-platform job platform with mobile screens, authentication flows, API integration, session handling, and scalable data flow across mobile, web, and Telegram.",
  },
  {
    type: "info",
    label: "Exam Time – Mobile App & Admin Portal:",
    content: "React Native, Realm, RTK Query, React Admin Portal",
  },
  {
    type: "info",
    label: "Exam Time:",
    content: "Improved production stability by fixing mobile crashes, Realm offline-data issues, navigation bugs, and admin portal state-management problems.",
  },
  {
    type: "hero",
    content: "Broader product and tooling work.",
  },
  {
    type: "info",
    label: "PSY / ሳይ:",
    content: "Psychology and self-authorship platform with a Go backend, PostgreSQL, Next.js app, admin dashboard, auth, consent flow, mood check-ins, privacy features, and deployment planning.",
  },
  {
    type: "info",
    label: "BetFind / BetFinder:",
    content: "Local marketplace platform for houses, furniture, services, and moving support, with product planning, backend structure, mobile flow, admin dashboard, roles, approvals, visit requests, payments, reports, and notifications.",
  },
  {
    type: "info",
    label: "Color Token Manager:",
    content: "Developer tool and VS Code extension for replacing hardcoded colors with reusable design tokens, including code scanning, previewing replacements, token path management, and marketplace publishing.",
  },
  {
    type: "info",
    label: "BookMe Addis:",
    content: "Local service booking marketplace with provider onboarding, service management, booking flows, customer discovery, provider pages, reviews, dashboard features, and a NestJS, Prisma, PostgreSQL backend.",
  },
  {
    type: "info",
    label: "Tamagn Express:",
    content: "Website and PWA project delivered for fast, installable web access across devices.",
  },
  {
    type: "info",
    label: "Lije Cares – Telegram Mini App:",
    content: "Built a React-based Telegram mini app with full multi-language support (i18n). `https://t.me/lijecaredev_bot`",
  },
  {
    type: "info",
    label: "Golden Arabian Majlis:",
    content: "Next.js and Supabase showcase site with categories, product pages, cart, contact pages, admin CRUD, QR page, SEO, sitemap, Cloudflare setup, and Search Console verification.",
  },
  {
    type: "info",
    label: "Figma Color Extractor:",
    content: "Design-tool extension for extracting colors from Figma and improving design-to-development workflows through reusable tokens and cleaner design system handoff.",
  },
  {
    type: "success",
    label: "Next:",
    content: "Use `case-studies`, `hire`, `contact`, or `github` if you want to talk through my work.",
  },
];

const experienceList = [
  {
    type: "info",
    label: "Eagle Lion System Technologies:",
    content: "Mobile Application Developer, Feb 2026 - Present, Addis Ababa, Ethiopia",
  },
  {
    type: "info",
    label: "Fintech:",
    content:
      "Implemented secure token-based authentication, local data storage, silent token refresh, and local queue retry mechanisms for production financial apps.",
  },
  {
    type: "info",
    label: "APIs:",
    content:
      "Integrated 8+ financial APIs for real-time transaction processing and collaborated with backend teams on API contracts.",
  },
  {
    type: "info",
    label: "TBC Technologies:",
    content: "Full Stack Developer, Mar 2025 - Feb 2026, Addis Ababa, Ethiopia",
  },
  {
    type: "info",
    label: "Production:",
    content:
      "Resolved 12+ critical production bugs, integrated REST APIs with retry logic and error boundaries, and worked through Git, code reviews, and pull requests.",
  },
  {
    type: "info",
    label: "TBC Technologies:",
    content: "Frontend Developer, Jun 2024 - Feb 2025, Addis Ababa, Ethiopia",
  },
  {
    type: "info",
    label: "Frontend:",
    content:
      "Developed responsive React and Next.js features, handled API data fetching, and managed global state for consistent UI/UX.",
  },
  {
    type: "success",
    label: "Next:",
    content: "Try `projects` to see the products and platforms I have worked on.",
  },
];

const contactList = [
  {
    type: "info",
    label: "Phone:",
    content: "`+251988280976`",
  },
  {
    type: "info",
    label: "Email:",
    content: "`dagmayalew489@gmail.com`",
  },
  {
    type: "info",
    label: "Portfolio:",
    content: "`https://www.dagmayalew.online/`",
  },
  {
    type: "info",
    label: "GitHub:",
    content: "`https://github.com/Dagmayalew`",
  },
  {
    type: "info",
    label: "Telegram:",
    content: "`https://t.me/dagmayalew`",
  },
  {
    type: "info",
    label: "LinkedIn:",
    content: "`https://www.linkedin.com/in/dagm-ayalew/`",
  },
];

const skillsList = [
  { type: "success", label: "Mobile:", content: "React Native, TypeScript, Flutter, Kotlin, Swift" },
  { type: "success", label: "State:", content: "Zustand, RTK Query, Realm, AsyncStorage" },
  { type: "success", label: "Frontend:", content: "React, Next.js, JavaScript" },
  { type: "warning", label: "Backend:", content: "REST APIs, JWT, NestJS, Firebase, Firestore, MySQL" },
  { type: "warning", label: "Tools:", content: "Git, Postman, Xcode, Android Studio, VS Code" },
  { type: "info", label: "Focus:", content: "Secure auth, API integration, performance, clean architecture, and smooth mobile UX" },
];

const caseStudiesList = [
  {
    type: "hero",
    content: "Detailed project highlights from featured professional work and broader product experience. Use `projects` for the quick list.",
  },
  {
    type: "info",
    label: "Dashen Bank:",
    content: "Implemented secure mobile banking features across React Native, TypeScript, and REST APIs, with attention to authentication, transaction flows, reusable UI patterns, loading states, and error handling.",
  },
  {
    type: "info",
    label: "CBE:",
    content: "Contributed to mobile banking features for a large-scale customer base, including API integrations, navigation patterns, and reliability improvements around critical financial operations.",
  },
  {
    type: "info",
    label: "Choice Micro Finance:",
    content: "Worked on microfinance mobile features with secure authentication, consistent UI components, optimized loading states, and stable error handling for sensitive financial workflows.",
  },
  {
    type: "info",
    label: "Order Ethiopia:",
    content: "I focused on mobile experience quality: reusable components, state management, product discovery, checkout, and the small interface details that make an e-commerce app feel dependable.",
  },
  {
    type: "info",
    label: "Worklance:",
    content: "Built cross-platform job platform screens, auth flows, API integration, session handling, and scalable data flow across mobile, web, and Telegram.",
  },
  {
    type: "info",
    label: "Exam Time:",
    content: "Improved stability by fixing mobile crashes, Realm offline-data issues, navigation bugs, and admin portal state-management problems.",
  },
  {
    type: "hero",
    content: "Broader product and tooling work.",
  },
  {
    type: "info",
    label: "PSY / ሳይ:",
    content: "I led the technical direction for the platform, shaping the app architecture around guided reflection, self-authorship prompts, consent, privacy, and a clean admin workflow across Go, PostgreSQL, and Next.js.",
  },
  {
    type: "info",
    label: "BetFind / BetFinder:",
    content: "I helped design the marketplace flow around local discovery, listing approvals, visits, payments, notifications, and admin operations so the product could scale with the company brand.",
  },
  {
    type: "info",
    label: "Color Token Manager:",
    content: "I published the extension and shaped it around a practical developer workflow: scan the codebase, preview replacements, and move hardcoded colors into tokens without breaking the design system.",
  },
  {
    type: "info",
    label: "BookMe Addis:",
    content: "I worked across customer discovery, provider setup, booking operations, and backend planning so the product could support a marketplace-style service flow end to end.",
  },
  {
    type: "info",
    label: "Tamagn Express:",
    content: "Website and PWA project delivered for fast, installable web access across devices.",
  },
  {
    type: "info",
    label: "Lije Cares – Telegram Mini App:",
    content: "Built a React-based Telegram mini app with full multi-language support (i18n), extending product access directly inside Telegram. `https://t.me/lijecaredev_bot`",
  },
  {
    type: "info",
    label: "Golden Arabian Majlis:",
    content: "I built the showcase and commerce layers together, with SEO, sitemap, admin CRUD, and deployment details handled so the site could serve both customers and operations cleanly.",
  },
  {
    type: "info",
    label: "Figma Color Extractor:",
    content: "The goal was to tighten the design-to-development loop by making color extraction and token reuse feel like part of the normal workflow rather than a one-off manual task.",
  },
  {
    type: "success",
    label: "Next:",
    content: "Type `resume`, `github`, `linkedin`, or `contact` for more.",
  },
];

const nowList = [
  {
    type: "hero",
    content: "Currently focused on production React Native fintech and e-commerce mobile work.",
  },
  {
    type: "info",
    label: "Current:",
    content: "Mobile Application Developer at Eagle Lion System Technologies, working on secure financial mobile workflows.",
  },
  {
    type: "info",
    label: "Best fit:",
    content: "React Native, TypeScript, secure auth, REST API integrations, state management, fintech, and e-commerce mobile apps.",
  },
  {
    type: "info",
    label: "Available for:",
    content: "Mobile app roles, React Native product work, and frontend/full-stack projects where strong mobile UX matters.",
  },
  {
    type: "success",
    label: "Next:",
    content: "Type `hire`, `projects`, `resume`, or `contact`.",
  },
];

const hireList = [
  {
    type: "hero",
    content: "Open to mobile app, frontend, and full-stack product work.",
  },
  {
    type: "info",
    label: "Best for:",
    content: "React Native, TypeScript, fintech and e-commerce mobile apps, REST API integration, auth flows, and production bug fixing.",
  },
  {
    type: "info",
    label: "Reach me:",
    content: "Use `contact`, `linkedin`, `email`, or call `+251988280976`.",
  },
  {
    type: "success",
    label: "Next:",
    content: "Type `contact`, `email`, or `resume` next.",
  },
];

const availabilityList = [
  {
    type: "hero",
    content: "Currently positioned for mobile app, frontend, and full-stack product work.",
  },
  {
    type: "info",
    label: "Best fit:",
    content: "Production React Native apps using TypeScript, REST APIs, JWT auth, Zustand, RTK Query, Realm, and clean mobile UX patterns.",
  },
  {
    type: "info",
    label: "Contact:",
    content: "Use `email`, `contact`, `linkedin`, or call `+251988280976`.",
  },
  {
    type: "success",
    label: "Next:",
    content: "Type `hire` for a quick summary or `email` to reach out directly.",
  },
];

export default {
  guide: {
    description: "Show a simple guide for new visitors.",
    aliasList: ["start", "helpme"],
    list: guideList,
  },
  about: {
    description: "Show a short introduction about Dagm.",
    aliasList: ["bio", "profile"],
    list: aboutList,
  },
  experience: {
    description: "Show Dagm's background and main areas of work.",
    aliasList: ["exp", "background"],
    list: experienceList,
  },
  projects: {
    description: "See the kind of work Dagm builds and where to view it.",
    aliasList: ["work", "portfolio"],
    list: projectsList,
  },
  contact: {
    description: "Show contact links and ways to reach Dagm.",
    aliasList: ["links", "reach"],
    list: contactList,
  },
  skills: {
    description: "Show the technologies Dagm works with most.",
    aliasList: ["skill", "stack"],
    list: skillsList,
  },
  "case-studies": {
    description: "Show deeper context for selected CV projects.",
    aliasList: ["cases", "case", "studies"],
    list: caseStudiesList,
  },
  now: {
    description: "Show Dagm's current focus and best-fit work.",
    aliasList: ["current", "focus"],
    list: nowList,
  },
  hire: {
    description: "See what kind of work Dagm is available for.",
    aliasList: ["services", "workwithme"],
    list: hireList,
  },
  availability: {
    description: "See Dagm's current availability and best-fit work.",
    aliasList: ["available", "status"],
    list: availabilityList,
  },
};
